import { useNavigate } from "react-router-dom";
import { useCurrentAnswer } from "@coffee/contexts";
import { useFetchAnswersQuery } from "@coffee/data-access/api-service";
import { Answer } from "@coffee/data-access/api-types";
import { NewQuestionButton } from "@coffee/ui/components/buttons";
import { LocalStorageKeys, useLocalStorage } from "@coffee/ui/hooks";
import styled from "@emotion/styled";
import { Spacing } from "@unlikelyai-magic/ui/layouts";
import { Heading } from "@unlikelyai-magic/ui/typography";
import { PreviousQuestions } from "./components";

const RecentsPageContainer = styled.div`
  // The height of the header bars are 4rem + 3rem
  height: calc(100vh - 7rem);
  padding: ${({ theme }) => theme.spacings["5xl"]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xl};
  width: 60%;
  margin: 0 auto;
`;

const HeadingContainer = styled(Spacing)`
  flex: 0 0 auto;
  width: 100%;
`;

const QuestionsContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
`;

export const Recents = () => {
  const navigate = useNavigate();
  const { setCurrentAnswer } = useCurrentAnswer();

  const [answerIds, _] = useLocalStorage<string[]>(
    LocalStorageKeys.ANSWER_IDS,
    []
  );

  const { data, isLoading, isFetching } = useFetchAnswersQuery({
    answerIds: answerIds,
  });

  const handleSelectAnswer = (answer: Answer) => {
    setCurrentAnswer(answer);
    navigate("/chat");
  };

  return (
    <RecentsPageContainer>
      <HeadingContainer
        direction="horizontal"
        justify="space-between"
        items="center"
      >
        <Heading level="h2">Previous Questions</Heading>
        <NewQuestionButton onClick={() => navigate("/chat")} />
      </HeadingContainer>
      <QuestionsContainer>
        <PreviousQuestions
          answers={data || []}
          isLoading={isLoading || isFetching}
          onSelect={handleSelectAnswer}
        />
      </QuestionsContainer>
    </RecentsPageContainer>
  );
};
